"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var AbstractPaginatedListStore = /** @class */ (function () {
    function AbstractPaginatedListStore() {
        var _this = this;
        this._loading = false;
        this._page = 0;
        this._items = [];
        this._error = null;
        this._isHaveNextPage = false;
        this.isHaveNextPage = function () { return _this._isHaveNextPage; };
        this.fetchPage = function (page) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var newItems_1, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (page < 0) {
                            return [2 /*return*/];
                        }
                        if (this._loading) {
                            throw new Error("Cannot fetch again. The last fetch still loading.");
                        }
                        mobx_1.runInAction(function () { return (_this._loading = true); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.getDataItemsPerPage(page)];
                    case 2:
                        newItems_1 = _a.sent();
                        mobx_1.runInAction(function () {
                            _this._isHaveNextPage = newItems_1.length === 20;
                            _this._items = newItems_1;
                            _this._page = page;
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        mobx_1.runInAction(function () { return (_this._error = e_1.message || "error"); });
                        throw e_1;
                    case 4:
                        mobx_1.runInAction(function () { return (_this._loading = false); });
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        this.refresh = function () {
            _this.fetchPage(_this.page);
        };
        this.clear = function () {
            mobx_1.runInAction(function () { return (_this._items = []); });
        };
        this.applyFilter = function (predicate) {
            mobx_1.runInAction(function () { return (_this._items = _this._items.filter(predicate)); });
        };
        this.nextPage = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.fetchPage(this._page + 1)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        this.previousPage = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.fetchPage(this._page - 1)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        this.setLoading = function (isLoading) {
            mobx_1.runInAction(function () { return (_this._loading = isLoading); });
            return null;
        };
        mobx_1.makeObservable(this, {
            _loading: mobx_1.observable,
            _page: mobx_1.observable,
            _items: mobx_1.observable,
            _error: mobx_1.observable,
            _isHaveNextPage: mobx_1.observable,
        });
    }
    Object.defineProperty(AbstractPaginatedListStore.prototype, "page", {
        get: function () {
            return this._page;
        },
        enumerable: false,
        configurable: true
    });
    AbstractPaginatedListStore.prototype.getPagination = function () {
        var _this = this;
        return {
            page: this.page,
            onNextClick: function () { return _this.nextPage(); },
            onPreviousClick: function () { return _this.previousPage(); },
        };
    };
    return AbstractPaginatedListStore;
}());
exports.default = AbstractPaginatedListStore;
